
import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";
import { JobIdProps } from "../interface/job_board";

export const apiGetGeneralStats = async (token: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  });
  try {
    const uri = `/admin/general-analytics`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
